import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogData } from '../../models/types/confirm-dialog.type';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
	standalone: true,
	selector: 'bt-confirm-modal',
	templateUrl: './confirm-modal.component.html',
	styleUrls: ['./confirm-modal.component.scss'],
	imports: [MatDialogModule, MatIconModule, MatButtonModule]
})
export class ConfirmModalComponent {
	readonly #dialogRef = inject(MatDialogRef<ConfirmModalComponent>);
	readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

	public onClose(confirm: boolean)  {
		this.#dialogRef.close(confirm);
	}
}
